import { Box, Heading } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import Footer from '@/components/Footer/Footer';
import { Logo } from '@/components/Logo';
import LandingHeader from '@/components/Nav/LandingHeader';
import { blue } from '@/theme/gradient';
import { PublicRegisterForm } from '@/components/Auth/PublicRegisterForm';
import { PATHNAMES } from '@/lib/routes';
import { useToastError } from '@/components/Toast';

const PublicRegisterPage = () => {
  const router = useRouter();
  const toastError = useToastError();

  const handleSuccess = () => {
    router.push(PATHNAMES.publicLogin);
  };

  const handleError = (error: Error) => {
    console.error(error);
    toastError({
      title: 'Chyba',
      description: `Během vytváření účtu nastala chyba (${error})`,
    });
  };

  return (
    <Box minH="100vh" bg="#0a0a0b">
      <LandingHeader
        zIndex="100"
        boxShadow={'1px 1px 1px #0000001f'}
        transition="box-shadow 0.3s ease-in-out"
        style={{ background: blue }}
      >
        <Link href={PATHNAMES.home} passHref>
          <Logo
            title="Homepage"
            alt="Homepage"
            ml={6}
            w={{ base: '116px', md: '116px' }}
            color={['white', 'white', 'primary.500', 'primary.500']}
          />
        </Link>
      </LandingHeader>
      <Box minH="60vh" py={20} bg="#f7f7f7">
        <Box
          p="6"
          borderRadius="md"
          bg="white"
          maxW="md"
          m="auto"
        >
          <Heading m="auto" size="lg" mb={4}>
            Registrace
          </Heading>
          <PublicRegisterForm onSuccess={handleSuccess} onError={handleError} />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default PublicRegisterPage;
